import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import { ShopModule } from '../components/app-icon/Icons'
import Stepper from '../components/ecom/Stepper/Stepper'
import EcomModule from '../components/ecom/EcomModule'
import CustomizeAll from '../components/сustomize-all/'
import TraficLight from '../components/traficLight'
import LicenseExpired from '../components/payment/LicenseExpired'
import { ActionsForUsing } from '../components/payment/LicenseExpired'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    maxWidth: 940,
    width: '100%',
  },
  header: {
    padding: '15px 40px 6px 22px',
  },
  content: {
    padding: '16px 40px 30px 22px',
  },

  viewList: {
    margin: 0,
    padding: 0,
  },

  list: {
    padding: 0,
    listStyleType: 'none',
  },
  item: {
    marginBottom: 12,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgb(255, 204, 0)',
    borderRadius: '100%',
    marginRight: 15,
  },
  chanelList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  chanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '13px 15px 13px 32px',
  },
  chanelInfo: {
    listStyleType: 'none',
    padding: 0,
    marginLeft: 8,
    marginRight: 65,
    flex: 1,
  },
  chanelTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.75)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: 1.6,
    color: 'rgba(0, 0, 0, 0.5)',
  },
  chanelStatusIcon: {
    width: 16,
    height: 16,
  },

  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {},
    '@media (min-width:960px)': {
      // eslint-disable-line no-useless-computed-key
      paddingLeft: theme.spacing.unit * 8,
      paddingRight: theme.spacing.unit * 8,
    },
  },
  link: {
    textDecoration: 'none',
  },
  toolbarInner: {
    padding: 0,
  },
  extendedIcon: {
    marginRight: 5,
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  list: {
    margin: '0 0 16px 0',
    padding: '7px 14px 10px 40px',
    listStyleType: 'none',
    borderRadius: 4,
  },
})

class Ecom extends Component {
  state = {
    site: window.state.site,
    isSetupEcom: window.state.ecom_setup_is_confirmed,
    showEcomError: false,
    errorsEcom: window.state.errorsEcom,
  }

  render() {
    const { classes } = this.props
    const { site, isSetupEcom, errorsEcom } = this.state

    const module = isSetupEcom ? (
      <Fragment>
        <EcomModule
          title={'Модуль "Электронная торговля"'}
          showEcomError={this.state.showEcomError}
        />
        {errorsEcom && errorsEcom.length > 0 ? (
          <Stepper siteName={site.url} errorsEcom={errorsEcom} />
        ) : null}
      </Fragment>
    ) : (
      <Stepper siteName={site.url} />
    )

    return (
      <Fragment>
        <LicenseExpired>
          <ActionsForUsing />
        </LicenseExpired>
        <div className={classes.pageTemplate}>
          <AppBar
            position="static"
            color="inherit"
            elevation={0}
            style={{ padding: '24px' }}
          >
            <Toolbar className={classes.toolbarInner}>
              <LogoData />

              <a className={classes.container} href={`http://${site.url.replace(/(http|https):\/\//is, '')}`} target="_blank">
                <div className={classes.siteIcon}>S</div>
                <ul className={classes.info}>
                  <Typography component="li" variant="body1">
                    {site.url}
                  </Typography>
                  <Typography component="li" variant="overline">
                    {site.name}
                  </Typography>
                </ul>
              </a>

              <TraficLight />
            </Toolbar>
          </AppBar>

          <CustomizeAll />

          <div className={classes.wizardRow}>
            <LeftNavigationDashboard />

            <div className={classes.wizardContent}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                }}
              >
                <div
                  style={{
                    width: 80,
                    height: 80,
                    borderRadius: '100%',
                    backgroundColor: 'rgb(255,217,72)',
                    overflow: 'hidden',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <ShopModule width={48} height={43} />
                </div>
                <Typography style={{ maxWidth: 664, marginLeft: 30 }}>
                  <strong>Модуль &quot;Электронная торговля&quot;</strong> будет
                  полезен интернет-магазинам, чтобы отслеживать кол-во проданных
                  с сайта товаров, добавлений товаров в корзину и т.д.
                </Typography>
              </div>
              <div style={{ marginLeft: 110, marginTop: 37 }}>{module}</div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withStyles(styles)(Ecom)
